import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line kinetic reveal (hero)
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="line-mask">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

// Scale-down scroll reveal for portfolio images (1.05 -> 1.0 inside overflow-hidden)
export const ScaleImage = ({ src, alt, className = "", imgClassName = "", watermark = true, fit = "cover" }) => (
  <div className={`relative overflow-hidden ${fit === "contain" ? "bg-secondary" : ""} ${className}`}>
    <motion.img
      src={src}
      alt={alt}
      loading="lazy"
      className={`img-frame h-full w-full ${fit === "contain" ? "object-contain" : "object-cover"} ${imgClassName}`}
      initial={{ scale: 1.12, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
    />
    {watermark && (
      <img
        src="/assets/brand/logo.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute bottom-3 left-3 h-14 md:h-20 w-auto opacity-40 grayscale drop-shadow-[0_1px_2px_rgba(0,0,0,0.35)] select-none z-10"
      />
    )}
  </div>
);
